import { ChannelType } from '../../shared/types/Channel';
import { ChannelCategory } from '../../shared/types/ChannelCategory';
import { SendingTime } from '../value-objects/SendingTime';
import { ChannelRuleEntity } from './ChannelRule';

export interface ChannelEntityProps {
  uuid: string;
  link: string;
  title?: string;
  type: ChannelType;
  isPrivate: boolean;
  minimalSendingInterval: number;
  sendingStartTime: string;
  sendingEndTime: string;
  category?: ChannelCategory;
  membersCount: number;
  rules?: ChannelRuleEntity[];
}

export class ChannelEntity {
  private readonly props: ChannelEntityProps;
  private constructor(props: ChannelEntityProps) { this.props = { ...props }; }
  static create(props: ChannelEntityProps) { return new ChannelEntity(props); }
  get uuid() { return this.props.uuid; }
  get link() { return this.props.link; }
  get title() { return this.props.title; }
  get type() { return this.props.type; }
  get isPrivate() { return this.props.isPrivate; }
  get minimalSendingInterval() { return this.props.minimalSendingInterval; }
  get sendingStartTime() { return this.props.sendingStartTime; }
  get sendingEndTime() { return this.props.sendingEndTime; }
  get sendingWindow() { return { start: SendingTime.fromIso(this.props.sendingStartTime), end: SendingTime.fromIso(this.props.sendingEndTime) }; }
  get category() { return this.props.category; }
  get membersCount() { return this.props.membersCount; }
  get rules(): ChannelRuleEntity[] { return this.props.rules ?? []; }
  withTitle(title?: string) { return new ChannelEntity({ ...this.props, title }); }
}
